import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { DataAccessEventsPageFacade } from '@planone/bau365/data-access-fair-data';
import { LinkClickEventType } from '@planone/bau365/feature-tracking';
import { Contributor, Event, Exhibitor } from '@planone/bau365/util-fair-data';

@Component({
  selector: 'bau365-event-section-contributors',
  templateUrl: './section-contributors.component.html',
  styleUrls: ['./section-contributors.component.scss'],
})
export class SectionContributorsComponent implements OnChanges {
  @Input() exhibitor?: Exhibitor;
  @Input() event?: Event;
  @Input() size?: string | null | undefined;
  @Input() contactClickable = true;

  @Output() linkClicked: EventEmitter<LinkClickEventType> = new EventEmitter<LinkClickEventType>();

  contributors: Contributor[] | undefined;

  constructor(private EventPageFacade: DataAccessEventsPageFacade) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['event'] && this.event && this.event.contributors) {
      this.contributors = this.event.contributors.sort((a, b) => (a.sort_order > b.sort_order ? 1 : -1));
    }
  }

  trackClick(element: EventTarget | null, linkType: string, linkText?: string, contactPersonId?: string) {
    if (this.event && this.exhibitor) {
      this.EventPageFacade.trackedItemClicked({
        htmlElement: element,
        linkType: linkType,
        exhibitor: this.exhibitor,
        event: this.event,
        context: this.exhibitor.fair_id,
        pageType: 'event-details',
        ...(linkText && { linkText: linkText }),
        ...(contactPersonId && { contactPersonId: contactPersonId }),
      });

      this.linkClicked.emit({
        entityType: 'CONTRIBUTOR',
        linkType: linkType,
        linkText: linkText,
        context: this.exhibitor.fair_id ?? '',
        pageType: 'event-details',
        eventTarget: element ?? undefined,
      });
    }
  }
}
